import { useAppSelector } from '../../../app/hooks'

export function useNote(noteId: string) {
  const note = useAppSelector((state) => state.notes.entities[noteId])?.data

  return note
}
